import PressableScale from '../PressableScale/PressableScale';
import React from 'react';
import { Animated, View } from 'react-native';
import { BACK_BUTTON_MARGIN, COLORS } from '../../config/designSystem/Colors';
import {
  BIG_HORIZONTAL_MARGIN_FN,
  REGULAR_HORIZONTAL_MARGIN_FN,
  SMALL_MARGIN_VERTICAL_FN,
  isWeb,
} from '../../config/designSystem/Layout';
import { FontAwesome } from '@expo/vector-icons';
import { ParagraphMRegular } from '../../config/designSystem/typography';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';


interface SurveyButtonProps {
  selectType: 'one' | 'multi';
  title: string;
  backgroundColor: string;
  textColor: string;
  onPress: (selected?: boolean) => void;
  selected?: boolean;
  inSession: boolean;
  WIDTH: number;
}

const SurveyButton = ({
  title,
  onPress,
  WIDTH,
  selectType,
  selected,
  backgroundColor,
  textColor,
  inSession,

}: SurveyButtonProps) => {
  const scaleAnimation = React.useRef(new Animated.Value(1)).current;
  const scaleAnimation1 = React.useRef(new Animated.Value(1)).current;
  const { width, height } = useAvailableDimensions();

  const color = backgroundColor ? backgroundColor : selectType === 'one' ? '#fff' : '#dadfe8';
  const textColorCopy = textColor ? textColor : '#5B5B5B';
  const SESSION_MARGIN = !isWeb ? 0 : BIG_HORIZONTAL_MARGIN_FN(width);

  const LEFT_MARGIN = inSession ? SESSION_MARGIN : selectType === 'one' ? 0 : BIG_HORIZONTAL_MARGIN_FN(width);
  const RIGHT_MARGIN = inSession ? SESSION_MARGIN : BACK_BUTTON_MARGIN;

  const MARGIN_HORIZONTAL = REGULAR_HORIZONTAL_MARGIN_FN(width);
  const WIDTH_BUTTON = 30;
  const LEFT_MARGIN_BUTTON = 2 * MARGIN_HORIZONTAL + WIDTH_BUTTON + WIDTH * 0.02;
  const RIGHT_MARGIN_BUTTON = 5;
  const WIDTH_TEXT = Math.max(80, WIDTH - LEFT_MARGIN - RIGHT_MARGIN - LEFT_MARGIN_BUTTON - RIGHT_MARGIN_BUTTON);
  const MIN_WIDTH = 120;
  const HEIGHT = Math.min(100, Math.max(40, height * 0.08));


  if (selectType === 'one') {
    return (
      <Animated.View style={{ transform: [{ scale: scaleAnimation1 }] }}>
        {selected ? (
          <PressableScale
            style={{
              backgroundColor: color,
              marginVertical: 5,
              justifyContent: 'center',
              alignItems: 'center',
              paddingVertical: 14,
              borderRadius: 30,
              shadowColor: '#000',
              shadowOffset: {
                width: 0,
                height: 5,
              },
              shadowOpacity: 0.23,
              shadowRadius: 2.62,
              elevation: 8,
              marginRight: RIGHT_MARGIN,
              marginLeft: LEFT_MARGIN,
              width: WIDTH - LEFT_MARGIN - RIGHT_MARGIN,
            }}
            onPress={() => onPress()}
            scaleAnimation={scaleAnimation1}
          >

            <ParagraphMRegular
              selectable={false}
              color={textColorCopy + 'FF'}
              align={true}
            >
              {title}
            </ParagraphMRegular>
          </PressableScale>
        ) : (
          <PressableScale
            style={{
              backgroundColor: color + 'BB',
              marginVertical: 5,
              justifyContent: 'center',
              alignItems: 'center',
              paddingVertical: 14,
              borderRadius: 30,
              marginRight: RIGHT_MARGIN,
              marginLeft: LEFT_MARGIN,
              width: WIDTH - LEFT_MARGIN - RIGHT_MARGIN,
            }}
            onPress={() => onPress()}
            scaleAnimation={scaleAnimation1}
          >
            <ParagraphMRegular
              selectable={false}
              color={textColorCopy + 'FF'}
              align={true}
            >
              {title}
            </ParagraphMRegular>
          </PressableScale>
        )}
      </Animated.View>
    );
  }
  if (selectType === 'multi') {
    return (
      <PressableScale
        onPress={() => {
          onPress(!selected);
        }}
        scaleAnimation={scaleAnimation}
      >
        <Animated.View
          style={{
            transform: [{ scale: scaleAnimation }],
            marginBottom: SMALL_MARGIN_VERTICAL_FN(height),
            minWidth: MIN_WIDTH,
          }}
        >
          <View
            style={{
              marginRight: RIGHT_MARGIN,
              marginLeft: LEFT_MARGIN,
              borderRadius: 30,
              paddingVertical: SMALL_MARGIN_VERTICAL_FN(height),
              backgroundColor: color,
              justifyContent: 'center',
            }}
          >
            <View
              style={{
                height: WIDTH_BUTTON,
                width: WIDTH_BUTTON,
                borderRadius: 15,
                backgroundColor: '#fff',
                alignItems: 'center',
                justifyContent: 'center',
                marginHorizontal: MARGIN_HORIZONTAL,
                position: 'absolute',
              }}
            >
              {selected && <FontAwesome name="check" size={20} color={COLORS.brand[500]} />}
            </View>

            <View
              style={{
                marginLeft: LEFT_MARGIN_BUTTON,
                marginRight: RIGHT_MARGIN_BUTTON,
                justifyContent: 'center',
                width: WIDTH_TEXT,
              }}
            >
              <ParagraphMRegular  color={textColorCopy}>
                {title}
              </ParagraphMRegular>
            </View>
          </View>
        </Animated.View>
      </PressableScale>
    );
  }
  return null;
};

export default SurveyButton;
